import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  UrlTree,
} from '@angular/router';
import { combineLatest, Observable, of } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';

import { WasteProfilesFacadeService } from '../waste-profiles-facade/waste-profiles-facade.service';

@Injectable({
  providedIn: 'root',
})
export class WasteProfilesFindGuard implements CanActivate {
  constructor(
    private facade: WasteProfilesFacadeService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    const wasteProfileId = route.params.wasteProfileId;

    return combineLatest([
      this.facade.loading$,
      this.facade.activeWasteProfile$.pipe(
        take(1),
        switchMap((profile) => {
          if (wasteProfileId) {
            return this.facade.findOrRefreshById(wasteProfileId);
          }

          return of(profile);
        })
      ),
    ]).pipe(
      take(1),
      map(([_, wasteProfile]) => {
        if (!wasteProfile) {
          return this.router.parseUrl('/waste-profiles/create');
        }

        return true;
      })
    );
  }
}
